<template>
  <CButton
    @click="copyToClipboard"
    class="clip"
    @mouseleave="handleMouseLeave"
    v-c-tooltip.hover.click="{
      content: tooltipContent,
      placement: 'top',
    }"
  >
    <CIcon name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
  </CButton>
</template>
<script>
export default {
  name: 'CopyAction',
  props: {
    copyReference: {
      type: String | Number,
      required: true,
    },
  },
  data() {
    return {
      copyClicked: false
    }
  },
  computed: {
    tooltipContent() {
      return this.copyClicked ? this.$t('copyAction.copied') : this.$t('copyAction.copy')
    }
  },
  methods: {
    handleMouseLeave() {
      setTimeout(() => {
        this.copyClicked = false
      }, 100)
    },
    copyToClipboard() {
      this.copyClicked = true
      navigator.clipboard.writeText(this.copyReference);
    }
  }
}
</script>
